import api from './api';
import { SCORM_STATS } from '../configs/routes';

export const getScormStats = () => 
    new Promise((resolve, reject) => {
        api.get(SCORM_STATS)
        .then((response) => resolve(response.data))
        .catch((err) => reject(err.message));
    }); 